import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Radio, Select, Input, Table} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew, DisplayForm} from '../../components';
import {openNotice} from 'Utils';
import {getOrderTraceBackHead} from '../../service/traceOrder';
import {toFixed2} from "../../utils";

/*获取产品列表接口*/
class TraceOrderDetail extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['追溯订单'],
            showHideBtnIndex: '',
            key: 0,
            id: this.props.params.orderId,
            selectedRowKeys: [],
            params: {
                id: '',
                s: 10,
                p: 1
            },
            displayData: [],
            rows: [],
            total: 1,
            searchObj: {
                name: '',
                category: [],
                active: '',
                s: 10,
                p: 1
            },
            categoryData: [],
            visible: false,
            value: ''
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);

        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.goBack = this.goBack.bind(this);
    };

    goBack() {
        hashHistory.goBack();
    }

    /*选择列表*/
    onSelectChange = (selectedRowKeys) => {
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*筛选*/
    setFilterParam(name, value) {
    };

    /*筛选重置*/
    advanceReset() {
    };

    /* 筛选确认 */
    advanceSubmit(form) {
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        getOrderTraceBackHead(this.state.id).then(result => {
            if (result && result.code == 200) {
                if (result.data.status == 1) {
                    result.data.orderStatusText = '提交'
                }
                if (result.data.status == 2) {
                    result.data.orderStatusText = '待审批'
                }
                if (result.data.status == 3) {
                    result.data.orderStatusText = '已确认'
                }
                if (result.data.status == 4) {
                    result.data.orderStatusText = '已完成'
                }
                if (result.data.status == 5) {
                    result.data.orderStatusText = '驳回'
                }
                if (result.data.status == 6) {
                    result.data.orderStatusText = '驳回后提交'
                }
                let arr = [
                    {label: '编号', value: result.data.orderNumber},
                    {label: '状态', value: result.data.orderStatusText},
                    {label: '订单日期', value: result.data.orderDate},
                    {label: '客户编号', value: result.data.customerNumber},
                    {label: '客户名称', value: result.data.cusName},
                    {label: '购货单位', value: result.data.purchaseName},
                    {label: '产品线', value: result.data.productLineName},
                    {label: '税率', value: result.data.taxCode + '%'},
                    {label: '反馈', value: result.data.feedback, span: 24}
                ];
                this.setState({
                    displayData: arr,
                    rows: result.data.lineBackList,
                    quantityCount: result.data.quantityCount,
                    diffAmount: result.data.diffAmount,
                    correctAmount: result.data.correctAmount
                });
            }
        })
        this.state.params.id = this.state.id;
        this.setState({params: {...this.state.params}})
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    showHideBtn(index) {
        this.setState({
            showHideBtnIndex: index
        });
    }

    hideBtn() {
        this.setState({
            showHideBtnIndex: ''
        });
    }

    addRecord(index) {
        console.log('adding ' + index);
    }

    handleOk = () => {
        this.setState({visible: false});
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    onChange = (e) => {
        this.setState({
            value: e.target.value
        });
    }

    handleChange() {

    }

    render() {
        var self = this;
        const {
            opts,
            key,
            rows,
            displayData,
            total,
            searchObj,
            selectedRowKeys,
            showHideBtnIndex,
            visible,
            quantityCount,
            diffAmount,
            correctAmount
        } = this.state;

        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                // {
                // 	title: '渠道',
                // 	dataIndex: 'salesChannelName'
                // },
                {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                },
                {
                    title: '物料描述',
                    dataIndex: 'itemDesc'
                },
                {
                    title: '出库单号',
                    dataIndex: 'deliveryId'
                },
                {
                    title: '发票池ID',
                    dataIndex: 'lineId'
                },
                {
                    title: '可用数量',
                    dataIndex: 'orderQuantity'
                },
                {
                    title: '数量',
                    dataIndex: 'qty'
                },
                {
                    title: '出库单价',
                    dataIndex: 'unitSellingPrice'
                },
                {
                    title: '正确单价',
                    dataIndex: 'correctPrice'
                },
                {
                    title: '单价差额',
                    dataIndex: 'priceDiff'
                },
                {
                    title: '出库总额',
                    dataIndex: 'outAmount'
                },
                {
                    title: '正确总额',
                    dataIndex: 'correctAmount'
                },
                {
                    title: '总额差异',
                    dataIndex: 'amountDiff'
                }
            ],
            rows
        };
        // const displayData = [
        // 	{label: '编号', value: '2016053100001'},
        // 	{label: '状态', value: '已提交'},
        // 	{label: '订单日期', value: '2016-05-31 15:30:45'},
        // 	{label: '客户编号', value: '100001'},
        // 	{label: '客户名称', value: '浙江电工张华'},
        // 	{label: '购货单位', value: '购货单位1'},
        // 	{label: '产品线', value: '产品线1'},
        // 	{label: '反馈', value: '反馈1'}
        // ];
        return (
            <div className="dms-main-box">
                <div>
                    <DmsTab options={opts} defaultKey={0}>
                        <Button onClick={this.goBack}>返回</Button>
                    </DmsTab>
                    <div className="dms-table-box">
                        <DisplayForm dataSource={displayData} perRow="4"/>
                        <div>
                            <DmsTab className="white-bg no-border" options={['订单物料']} defaultKey={0}/>
                            <div className="dms-table-box">
                                <TableView {...tableViewProps} />
                            </div>
                            <div className="order_amount">
                                <p><span
                                    style={{float: 'right'}}>数量汇总：{quantityCount}</span>
                                </p>
                                <p><span
                                    style={{float: 'right'}}>正确总额汇总：{correctAmount}</span>
                                </p>
                                <p><span
                                    style={{float: 'right'}}>总额差异汇总：{diffAmount}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
;
export default withRouter(TraceOrderDetail);


// WEBPACK FOOTER //
// ./src/routes/traceOrder/detail.js